import { useQuery } from "@tanstack/react-query";
import { mvpApiGetProduct, ProductSchema } from "@labeling-tools/api/atlas";

export function useAtlasProduct(productId: string | null) {
  return useQuery({
    queryKey: ["fetch-atlas-product", productId],
    queryFn: async () => {
      const response = await mvpApiGetProduct({
        path: {
          product_id: productId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch product: ${response.error}`);
      }

      return response.data as ProductSchema;
    },
    enabled: !!productId,
  });
}
